import EventMarkets from './EventMarkets';

export default EventMarkets;
